import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  closeModal(event) {
    event.preventDefault()

    this.element.remove()
  }
}
